import request from '@/utils/request'

// 查询快码列表
export function apiLookupDataList (query) {
  return request({
    url: '/system/lookup/data/list',
    method: 'get',
    params: query
  })
}

// 新增快码
export function apiLookupDataAdd (data) {
  return request({
    url: '/system/lookup/data',
    method: 'post',
    data: data
  })
}

// 修改快码
export function apiLookupDataUpdate (data) {
  return request({
    url: '/system/lookup/data',
    method: 'put',
    data: data
  })
}

// 删除快码
export function apiLookupDataDelete (dictId) {
  return request({
    url: `/system/lookup/data/${dictId}`,
    method: 'delete'
  })
}
